import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { styled } from 'styled-components';
import CursorNormal from './CursorNormal.js';
import { CursorMode } from '../../../types/presence.js';
import { getUserColorFromId, getTextColor } from '@fabric-app/utils/color';

const CursorWrapper = styled.div.withConfig({
  displayName: "SpaceCursor__CursorWrapper",
  componentId: "sc-561f29d7-0"
})([
  `position:absolute;left:0;top:0;transform-origin:center center;transition:transform 0.1s linear;`
]);
const CursorName = styled.span.withConfig({
  displayName: "SpaceCursor__CursorName",
  componentId: "sc-561f29d7-1"
})([
  `display:flex;flex-direction:column;justify-content:center;flex-shrink:0;padding:4px 4px;height:23px;color:#fff;text-align:center;font-family:Inter,sans-serif;font-size:13.8px;font-style:normal;font-weight:700;white-space:nowrap;border:2.4px solid white;position:absolute;margin-top:-10px;left:20px;`
]);
const CursorChat = styled(CursorName).withConfig({
  displayName: "SpaceCursor__CursorChat",
  componentId: "sc-561f29d7-2"
})([
  `white-space:pre-wrap;word-break:break-word;max-width:200px;width:max-content;height:auto;min-height:23px;border-radius:16px;padding:4px 8px;border-top-left-radius:0;font-weight:500;justify-content:flex-start;text-align:left;`
]);
const SpaceCursor = ({ user, bodyContext }) => {
  const x = useMemo(() => (user.presence.cursor?.position.x ?? 0) * (bodyContext.scrollWidth ?? 0), [
    bodyContext.scrollWidth,
    user.presence.cursor?.position.x
  ]);
  const y = useMemo(() => (user.presence.cursor?.position.y ?? 0) * (bodyContext.scrollHeight ?? 0), [
    user.presence.cursor?.position.y,
    bodyContext.scrollHeight
  ]);
  const color = getUserColorFromId(user.id);
  const textColor = getTextColor(color);
  if (!user.id) return null;
  return /* @__PURE__ */ jsxs(CursorWrapper, {
    style: {
      transform: `translate3d(${x}px, ${y}px, 0px)`
    },
    children: [
      /* @__PURE__ */ jsx(CursorNormal, {
        style: {
          width: 32,
          height: 32
        },
        color
      }),
      user.presence.cursor?.state?.mode !== CursorMode.Chat ? /* @__PURE__ */ jsx(CursorName, {
        style: {
          background: color,
          color: textColor
        },
        children: user.info.name
      }) : /* @__PURE__ */ jsx(CursorChat, {
        style: {
          background: color,
          color: textColor
        },
        children: user.presence.cursor.state.message.length > 0 ? user.presence.cursor.state.message : user.presence.cursor.state.previousMessage ?? "..."
      })
    ]
  });
};

export { SpaceCursor as default };
//# sourceMappingURL=SpaceCursor.js.map
